import { EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';
var AppComTipComponent = (function () {
    function AppComTipComponent(commonService) {
        this.commonService = commonService;
        this.sureText = "确定";
        this.cancelText = "取消";
        this.desText = "";
        this.onSure = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.outPutPrivate = new EventEmitter();
        this.isHarmonyOS = false; //是否鸿蒙系统
    }
    AppComTipComponent.prototype.ngOnInit = function () {
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        this.theme = this.theme ? this.theme : 'dark';
    };
    AppComTipComponent.prototype.sure = function () {
        this.onSure.emit();
    };
    AppComTipComponent.prototype.cancel = function () {
        this.onCancel.emit();
    };
    AppComTipComponent.prototype.check = function () {
        if ($('#private').hasClass('active')) {
            $('#private').removeClass('active');
            this.outPutPrivate.emit(1);
        }
        else {
            $('#private').addClass('active');
            this.outPutPrivate.emit(0);
        }
    };
    return AppComTipComponent;
}());
export { AppComTipComponent };



// WEBPACK FOOTER //
// ./src/app/app-com-tip/app-com-tip.component.ts.pre-build-optimizer.js